var map = {
	"./BUSINESS.svg": "3a68",
	"./CRM.svg": "16f4",
	"./EMAIL.svg": "9336",
	"./MINI_PROGRAM.svg": "c4ac",
	"./MOBILE.svg": "c55a",
	"./OFFLINE.svg": "5fbf",
	"./ONLINE.svg": "2d83",
	"./OPEN.svg": "febe",
	"./THIRD.svg": "5d32",
	"./YOUZAN.svg": "3d97",
	"./addicon.svg": "0a85",
	"./call-disabled.svg": "774b",
	"./call.svg": "7126",
	"./check.svg": "d813",
	"./detail-disabled.svg": "5d3d",
	"./detail.svg": "1464",
	"./label-disabled.svg": "3fdd",
	"./label.svg": "0187",
	"./loading.svg": "8187",
	"./log-disabled.svg": "350b",
	"./log.svg": "4a33",
	"./no_user_data.svg": "8d6b",
	"./wechat.svg": "4ad8",
	"./writing-fluently.svg": "8a06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd51";